module.exports = __webpack_public_path__ + "static/filmdrop-ui-au-bushfires-c5f580b27ec621164671b04e4d39a627.jpg";